import { organizationTypes } from 'common/constants';

// Organization type, not role: isSeller() also matches Administrators, which super admins carry.
export default function isSellerOrganization(rootStore) {
	const abrv = rootStore.applicationStore.organizationType;
	return !!abrv && abrv.toUpperCase() === organizationTypes.seller.toUpperCase();
}
